import { Transition } from "@headlessui/react";
import { ReactNode, useState } from "react";
import React from "react";

export type Props = {
  children: ReactNode;
  text: ReactNode;
  justify?: "START" | "END" | "CENTER";
  width?: "SMALL" | "MED" | "LARGE" | "XL" | "FIT";
  position?: "TOP" | "BOTTOM";
  duration?: string;
};

export default function Tooltip({ children, text, justify = "CENTER", width, position = "TOP", duration }: Props): JSX.Element {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  return (
    <div className={`relative transition-all`} onMouseOver={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)}>
      <Transition
        show={isVisible}
        enter={`transition ease-out ${duration ?? "duration-100"} transform`}
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave={`transition ease-in ${duration ?? "duration-75"} transform`}
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        {(ref) => (
          <div
            ref={ref}
            className={`flex justify-${justify === "START" ? "start" : justify === "END" ? "end" : justify === "CENTER" ? "center" : ""} transition-opacity`}
          >
            <div
              className={`absolute top-0 z-10 ${
                width === "MED" ? "w-32" : width === "LARGE" ? "w-48" : width === "SMALL" ? "w-15" : width === "FIT" ? "w-max" : "w-64"
              }
              ${position === "BOTTOM" ? "translate-y-full" : "-translate-y-full mt-3"}
              p-2 -mt-1 text-xs font-semibold transform leading-tight text-white whitespace-normal bg-gray-600 rounded-lg shadow-lg text-center`}
            >
              {text}
            </div>
          </div>
        )}
      </Transition>
      <div className="flex">{children}</div>
    </div>
  );
}
